import { render, staticRenderFns } from "./doctorCard.vue?vue&type=template&id=055ff40b&scoped=true&"
import script from "./doctorCard.vue?vue&type=script&lang=js&"
export * from "./doctorCard.vue?vue&type=script&lang=js&"
import style0 from "./doctorCard.vue?vue&type=style&index=0&id=055ff40b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ff40b",
  null
  
)

export default component.exports